import React from 'react';

const GaugeChart = ({ value }) => {
  const center = 100;
  const radius = 68;
  const strokeWidth = 14;
  const circumference = 2 * Math.PI * radius; // ~427.25
  const fillPercentage = 0.65; // Gauge fill amount (65%)
  const strokeDashoffset = circumference * (1 - fillPercentage);

  return (
    <svg width="180" height="180" viewBox="0 0 200 200" style={{ display: 'block', margin: 'auto' }}>
      <defs>
        <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#C084FC" />
        </linearGradient>
      </defs>
      {/* Background Circle */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="#F3F4F6"
        strokeWidth={strokeWidth}
      />
      {/* Foreground Indicator */}
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="url(#gaugeGradient)"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        transform="rotate(-90 100 100)"
      />
      {/* Center Texts */}
      <text
        x={center}
        y={center + 5}
        textAnchor="middle"
        style={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 700,
          fontSize: '22px',
          fill: '#1e293b'
        }}
      >
        {value.toLocaleString()}
      </text>
      <text
        x={center}
        y={center + 24}
        textAnchor="middle"
        style={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 500,
          fontSize: '11px',
          fill: '#94a3b8'
        }}
      >
        Average
      </text>
    </svg>
  );
};

export default GaugeChart;
